import { Button, Paper, Typography, useTheme } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'
import { useAuth } from '../../providers/auth'
import { colors } from '../../theme/options'

import { useConfig } from '../../providers/envConfig'
import { FirstPartyPlatformType } from '../../types/Account'

interface ExpirationHeaderProps {
  showLogoutButton?: boolean
}

const ExpirationHeader = ({ showLogoutButton = false }: ExpirationHeaderProps) => {
  const { authState } = useAuth()
  const jwt = authState?.jwt || null
  if (jwt === null) return null

  const envConfig = useConfig()
  const { t } = useTranslation()
  const theme = useTheme()

  const secondsLeft = Math.floor(jwt.payload.exp - Math.floor(Date.now() / 1000))
  const minutesLeft = secondsLeft > 0 ? Math.floor(secondsLeft / 60) : 0

  const handleLogout = () => {
    const logoutURI = window.location.origin + '/logout'
    switch (authState.accountInfo?.firstPartyPlatformType) {
      case FirstPartyPlatformType.PLAYSTATIONNETWORK: {
        const psnLogoutURL = new URL(envConfig.playStation.logoutURL)
        psnLogoutURL.searchParams.set('client_id', envConfig.playStation.clientId)
        psnLogoutURL.searchParams.set('redirect_uri', logoutURI)
        window.location.href = psnLogoutURL.toString()
        break
      }
      case FirstPartyPlatformType.XBOXLIVE: {
        const xboxLogoutURL = new URL(envConfig.xbox.logoutURL)
        xboxLogoutURL.searchParams.set('post_logout_redirect_uri', logoutURI)
        window.location.href = xboxLogoutURL.toString()
        break
      }
    }
  }
  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        width: '100%',
        backgroundColor: colors.teal[50],
      }}
      data-testid="expiration-header"
    >
      <Typography
        variant="bodyMedium"
        component="p"
        sx={{ color: colors.teal[900], p: theme.spacing(1.5), mx: theme.spacing(2.5) }}
      >
        <Trans
          i18nKey={
            secondsLeft >= 1 && secondsLeft < 60
              ? 'vpc:childLandingPage.JWTExpirationMessageLessThanAMinute'
              : 'vpc:childLandingPage.JWTExpirationMessage'
          }
          values={{
            minutesLeft: minutesLeft,
            count: minutesLeft,
            loggedOutAt: new Date(jwt.payload.exp * 1000).toLocaleTimeString(),
          }}
        />
      </Typography>
      {showLogoutButton && (
        <Button
          variant="outlined"
          onClick={handleLogout}
          sx={{
            my: theme.spacing(1),
            mx: theme.spacing(2.5),

            '&:hover': {
              borderColor: theme.palette.grey[900],
            },

            [theme.breakpoints.down('lg')]: {
              mx: 'auto',
            },
          }}
        >
          <Typography variant="buttonMedium" component="h3">
            {t('vpc:logoutButton')}
          </Typography>
        </Button>
      )}
    </Paper>
  )
}

export default ExpirationHeader
